import { Button } from "@similarweb/ui-components";

import { swSettings } from "app/common/services/swSettings";
import { usePageTopBannerStripReveal } from "app/components/PageTopBanner/bannerRevealContext";
import { useShowDiscountPopup } from "app/components/React/TrialBanner/DiscountBanner/hooks";
import { TRIAL_BANNER_ID } from "app/common/constants/trialBanner";
import { getFormattedTimeLeft } from "app/components/timers/utils/helpers";
import { i18nFilter } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";
import { goToPackagesPage } from "app/UtilitiesAndConstants/UtilityFunctions/goToPackagesPage";

import { DiscountPopup } from "./DiscountPopup/DiscountPopup";
import { DiscountBannerContent } from "./StyledDiscountBanner";
import { TimeCountingDiscount } from "./TimeCountingDiscount/TimeCountingDiscount";

interface IDiscountBannerProps {
    isSticky: boolean;
}

const DiscountBanner = ({ isSticky }: IDiscountBannerProps) => {
    const { shouldShowDiscountPopup, setShouldShowDiscountPopup, discountEndTime } = useShowDiscountPopup(swSettings);
    const i18n = i18nFilter();
    const stripProps = usePageTopBannerStripReveal();

    const discountEndDateFromSettings = swSettings.user?.customData?.DiscountEndDate;

    const handleCTAClick = () => {
        const formattedTimeLeft = getFormattedTimeLeft({ discountEndDateFromSettings, discountEndTime });
        allTrackers.dispatchTrackEvent("Internal Link", "click", `TrialBanner/Discount Banner/${formattedTimeLeft}`);
        goToPackagesPage();
    };

    return (
        <DiscountBannerContent
            {...stripProps}
            isSticky={isSticky}
            id={TRIAL_BANNER_ID}
            data-automation="discount-banner"
        >
            <TimeCountingDiscount
                discountEndDateFromSettings={discountEndDateFromSettings}
                discountEndTime={discountEndTime}
            />

            {shouldShowDiscountPopup ? (
                <DiscountPopup
                    setShouldShowDiscountPopup={setShouldShowDiscountPopup}
                    discountEndTime={discountEndTime}
                />
            ) : null}

            <Button
                type="inverted"
                width={136}
                onClick={handleCTAClick}
            >
                {i18n("discount_banner.button.claim_offer")}
            </Button>
        </DiscountBannerContent>
    );
};

export default DiscountBanner;
